import {
  RECEIVE_CONFIGURATION,
  RECEIVE_CONFIGURATION_ERROR,
  RESET_CONFIGURATION_ERROR,
  SET_CONFIGURATION_CHANGED,
  SET_LOAD_CODE,
  SET_LOAD_IDENTIFIER,
  RECEIVE_OPTIONS,
  RECEIVE_CALCULATION,
  SET_LOADING,
  RECEIVE_CALCULATION_ERROR,
  RESET_CODE,
} from "./Actions";
import find from "lodash/find";

const initialState = {
  configuration: null,
  configurationChanged: false,
  calculation: {},
  error: null,
  loadCode: null,
  loadIdentifier: null,
  optionsLoaded: false,
  isLoading: false,
  artusIdentifierAttributeValueMap: new Map(),
  artusComponentOptions: [
    {
      key: "height",
      identifier: "frontend_height",
      options: [],
    },
    {
      key: "width",
      identifier: "frontend_width",
      options: [],
    },
    {
      key: "row",
      identifier: "frontend_layers",
      options: [],
    },
    {
      key: "weight",
      identifier: "frontend_shelfLoad",
      options: [],
    },
    {
      key: "sicherung",
      identifier: "frontend_securing",
      options: [],
    },
    {
      key: "bullbar",
      identifier: "frontend_bullbar",
      options: [],
    },
    {
      key: "floor",
      identifier: "frontend_shelfBottom",
      options: [],
    },
  ],
  bertArchiveComponentOptions: [
    {
      key: "height",
      identifier: "frontend_height",
      options: [],
    },
    {
      key: "depth",
      identifier: "frontend_depth",
      options: [],
    },
    {
      key: "row",
      identifier: "frontend_layers",
      options: [],
    },
    {
      key: "shelfLoad",
      identifier: "frontend_shelfLoad",
      options: [],
    },
    {
      key: "width",
      identifier: "frontend_width",
      options: [],
    },
  ],
  bertWarehouseComponentOptions: [
    {
      key: "height",
      identifier: "frontend_height",
      options: [],
    },
    {
      key: "depth",
      identifier: "frontend_depth",
      options: [],
    },
    {
      key: "row",
      identifier: "frontend_layers",
      options: [],
    },
    {
      key: "shelfLoad",
      identifier: "frontend_shelfLoad",
      options: [],
    },
    {
      key: "width",
      identifier: "frontend_width",
      options: [],
    },
  ],
};

export default function ConfigurationReducer(state = initialState, action = {}) {
  switch (action.type) {
    case RECEIVE_CONFIGURATION: {
      return {
        ...state,
        configuration: action.data,
      };
    }
    case SET_LOADING: {
      return {
        ...state,
        isLoading: action.data,
      };
    }
    case RECEIVE_CONFIGURATION_ERROR: {
      return {
        ...state,
        error: action.error,
      };
    }
    case RECEIVE_CALCULATION: {
      const { data: calculation } = action;
      return {
        ...state,
        calculation,
      };
    }

    case RESET_CONFIGURATION_ERROR: {
      return {
        ...state,
        error: null,
      };
    }
    case SET_LOAD_CODE: {
      return {
        ...state,
        loadCode: action.loadCode,
        loadIdentifier: null,
      };
    }

    case SET_LOAD_IDENTIFIER: {
      return {
        ...state,
        loadIdentifier: action.loadIdentifier,
        loadCode: null,
      };
    }

    case RECEIVE_CALCULATION_ERROR: {
      return {
        ...state,
        calculation: {
          price: "---",
          calculationError: true,
        },
      };
    }

    case RECEIVE_OPTIONS: {
      const { item, key, options } = action;
      const newState = state;
      if (item === "artus") {
        const identifierAttributeValueMap = state.artusIdentifierAttributeValueMap;
        find(newState.artusComponentOptions, (component) => component.key === key).options = options;
        newState.optionsLoaded = true;
        newState.artusComponentOptions.forEach((component) => {
          if (component.options.length === 0) {
            newState.optionsLoaded = false;
          }
        });
        newState.artusComponentOptions.forEach((artusComponentOption) => {
          artusComponentOption.options.map((option, i) => {
            const identifier = option.identifier;
            if (identifier.substring(0, 15) === "frontend_height") {
              const attribute = find(option.attributes, { identifier: "height" });
              const widthAttribute = find(option.attributes, { identifier: "width" });
              identifier &&
                attribute &&
                attribute.values &&
                identifierAttributeValueMap.set(identifier, attribute.values[0].value);
              identifier &&
                widthAttribute &&
                widthAttribute.values &&
                identifierAttributeValueMap.set(`${identifier}_frameWidth`, widthAttribute.values[0].value);
            } else if (identifier.substring(0, 14) === "frontend_width") {
              const attribute = find(option.attributes, { identifier: "width" });
              identifierAttributeValueMap.set(identifier, attribute.values[0].value);
            } else if (identifier.substring(0, 18) === "frontend_shelfLoad") {
              const attribute = find(option.attributes, { identifier: "calculationValue" });
              identifierAttributeValueMap.set(identifier, attribute.values[0].value);
            }
          });
        });
        newState.artusIdentifierAttributeValueMap = identifierAttributeValueMap;
      } else if (item === "bertArchive") {
        find(newState.bertArchiveComponentOptions, (component) => component.key === key).options = options;
        newState.optionsLoaded = true;
        newState.bertArchiveComponentOptions.forEach((component) => {
          if (component.options.length === 0) {
            newState.optionsLoaded = false;
          }
        });
      } else if (item === "bertWarehouse") {
        find(newState.bertWarehouseComponentOptions, (component) => component.key === key).options = options;
        newState.optionsLoaded = true;
        newState.bertWarehouseComponentOptions.forEach((component) => {
          if (component.options.length === 0) {
            newState.optionsLoaded = false;
          }
        });
      }
      return newState;
    }

    case RESET_CODE: {
      const configuration = state.configuration;
      if (configuration) {
        configuration.code = null;
      }
      return {
        ...state,
        configuration,
      };
    }

    case SET_CONFIGURATION_CHANGED: {
      const { changed } = action;
      return {
        ...state,
        configurationChanged: changed,
      };
    }

    default:
      return state;
  }
}
